/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ServiceAddressUpdate = {
    properties: {
        id: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        type: {
            type: 'ServiceAddressTypeEnum',
        },
        street: {
            type: 'string',
            isNullable: true,
        },
        city: {
            type: 'string',
            isNullable: true,
        },
        state: {
            type: 'string',
            isNullable: true,
            maxLength: 2,
        },
        zip: {
            type: 'string',
            isNullable: true,
            maxLength: 10,
        },
        zip4: {
            type: 'string',
            isNullable: true,
            maxLength: 4,
        },
    },
};